// @ts-nocheck
import ga from "@store/Framework/Common/GoogleAnalytics";
import { TrackAddAllItemsAndCheckoutParameters } from "@store/Framework/Common/GoogleAnalytics/trackers/quickOrder/trackAddAllItemsAndCheckout";

const useTrackAddAllItemsAndCheckout = (
    parameters: TrackAddAllItemsAndCheckoutParameters = {},
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.util.getEventTrackerHook(ga.track.addAllItemsAndCheckout, parameters, options);
};

export default useTrackAddAllItemsAndCheckout;
